import { createFileRoute, Link, Outlet, redirect } from "@tanstack/react-router";

import { css } from "~/styled-system/css";

export const Route = createFileRoute("/storybook")({
  component: RouteComponent,
  beforeLoad(ctx) {
    if (ctx.matches.at(-1)?.id === "/storybook") {
      throw redirect({ to: "/storybook/primitives" });
    }
  },
});

function RouteComponent() {
  return (
    <div className={mainStyles}>
      <nav className={navStyles}>
        <Link to="/storybook/primitives" className={linkStyles}>
          Primitives
        </Link>
        <Link to="/storybook/audio-trimmer" className={linkStyles}>
          Audio Trimmer
        </Link>
        <Link to="/storybook/video" className={linkStyles}>
          Video Player
        </Link>
        <Link to="/storybook/cropper" className={linkStyles}>
          Cropper
        </Link>
        <Link to="/storybook/clip-sequence-selector" className={linkStyles}>
          Clip Sequence Selector
        </Link>
      </nav>
      <Outlet />
    </div>
  );
}

const mainStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
  color: "$gray.10",
  height: "calc(100dvh - 32px)",
});

const navStyles = css({
  display: "flex",
  gap: "16px",
});

const linkStyles = css({
  textUnderlineOffset: "2px",

  "&:hover": {
    textDecoration: "underline",
  },

  "&[data-status=active]": {
    textDecoration: "underline",
    textDecorationColor: "$purple",

    "&:hover": {
      textDecorationColor: "$purple",
    },
  },
});
